import { render, staticRenderFns } from "./suContractRpeortList.vue?vue&type=template&id=10cc7f38"
import script from "./suContractRpeortList.vue?vue&type=script&lang=js"
export * from "./suContractRpeortList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports